﻿import $ from 'jquery';

var inputsOnlySelector: string = 'input, .dropdown-input, textarea, button[data-dismiss], button[data-ms-user-facing-input], button[data-daterange-display], [data-file-field]';
var allElementsSelector: string = '[data-tab], button, ' + inputsOnlySelector;

export class Focus {
  public static autoFocus($container?: JQuery): void {
    var $resolvedContainer = $container || $(<any> document);

    var $focus = $resolvedContainer.find('[autofocus]');
    if ($focus.length == 1)
      $focus.focus();
    else
      Focus.focusFirstInput($resolvedContainer);
  }

  public static focusContainer($container?: JQuery): void {
    var $resolvedContainer = $container || $(<any> document);
    Focus.focusFirstElement($resolvedContainer);
  }

  public static focusFirstElement($container: JQuery): void {
    focusFirst($container, allElementsSelector);
  }

  public static focusFirstInput($container: JQuery): void {
    focusFirst($container, inputsOnlySelector);
  }

  public static focusLastElement($container: JQuery): void {
    focusLast($container, allElementsSelector);
  }

  public static focusLastInput($container: JQuery): void {
    focusLast($container, inputsOnlySelector);
  }



  public static after(action: Function) {
    let element = document.activeElement as HTMLElement;
    let elementId = element.id;
    if (!elementId) {
      action();
      return;
    }

    let isCheckbox = element.matches('[type="checkbox"]');
    let caretPosition;
    if (!isCheckbox && element instanceof HTMLInputElement)
      caretPosition = element.selectionStart;

    action();

    var updatedDomElement = document.getElementById(elementId);
    if (updatedDomElement) {
      updatedDomElement.focus();
      if (updatedDomElement instanceof HTMLInputElement && caretPosition) {
        updatedDomElement.selectionStart = caretPosition;
        updatedDomElement.selectionEnd = caretPosition;
      }
    }
  }
}

var focusFirst = function ($container: JQuery, selector: string): void {
  var $focus = $container.find(selector).filter(':visible').not('[readonly="readonly"]').first();
  if ($focus.length > 0) {
    $focus.focus();
  }
}

var focusLast = function ($container: JQuery, selector: string): void {
  var $focus = $container.find(selector).filter(':visible').not('[readonly="readonly"]').last();
  if ($focus.length > 0) {
    $focus.focus();
  }
}

export default Focus;
